import {
  ServiceRequestsWidgetItem,
  Widget,
  WidgetContentItemsList,
} from '../../Widget'

import { getServiceRequestListItemProps } from './RequestsWidget.utils'

function RequestsWidget({
  Item = ServiceRequestsWidgetItem,
  getItemPropsFromValue = getServiceRequestListItemProps,
  isSkeleton,
  items,
  widgetContentItemsProps,
  widgetProps,
}) {
  return (
    <Widget
      {...widgetProps}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
    >
      <WidgetContentItemsList
        {...widgetContentItemsProps}
        Item={Item}
        getItemPropsFromValue={getItemPropsFromValue}
        items={items}
      />
    </Widget>
  )
}

export default RequestsWidget
